import { WaybillIdType } from '../constants';

export interface WaybillIdView {
  carrierId: string;
  carrierTO: string;
  hawb: string;
  hbl: string;
  mbl: string;
  internalWaybillId: string;
  waybillIdType: WaybillIdType;
}
export interface LoadIdView {
  loadNumber: string;
}

export interface TransportOrderIdView {
  transportOrderNumber: string;
}

export interface SpecialFreightIdView {
  reference: string;
  subReference: string;
}

export interface HandlingUnitIdView {
  huId: string;
  deliveryNoteNumber: string;
}
